import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const ChartContainer = styled('div')(`
  svg {
    overflow: visible;
  }
`);

